/* ============================================================
   MUSE DISC — Marquee JS
   Pure CSS animation handles infinite scroll.
   JS handles hover pause only.
   ============================================================ */

(function () {
  document.querySelectorAll('.marquee').forEach(function (el) {
    el.addEventListener('mouseenter', () => el.classList.add('marquee--paused'));
    el.addEventListener('mouseleave', () => el.classList.remove('marquee--paused'));
  });
})();
